import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
  Table
} from 'reactstrap';

import styles from './style.module.scss';

import InfoIcon from '../../../assets/images/icons/info.svg';
import EditIcon from '../../../assets/images/icons/edit.svg';
import EditAllIcon from '../../../assets/images/icons/edit-all.svg';
import MoreIcon from '../../../assets/images/icons/more.svg';
import DirectionIcon from '../../../assets/images/icons/direction-fill.svg';

import { IPlanningData, IPlanningPayload } from '../../../interfaces/rolling-plan-planning.interface';
import { IMeasureVisibility, IMeasureVisibilityPayload } from '../../../interfaces/common.interface';
import {
  CopyDataToPlan,
  GetRollingPlanData,
  UpdateRollingPlanData,
  FreezePlan,
  ImportTemplate, GoalSeek
} from '../../../api-services/rolling-plan.api';
import { DownloadTemplate, UpdateMeasureVisibility } from '../../../api-services/common.api';

import SectionLoader from '../../../components/Common/loader/SectionLoader';
import InitialMessage from '../../../components/Common/initial-message/initial-message';
import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import InvalidData from '../../../components/Common/invalid-data/invalid-data';
import ActionCard from '../../../components/Footer/ActionCard';
import UnsavedDataModal from '../../../components/Common/Modals/UnsavedDataModal';
import SuccessModal from '../../../components/Common/Modals/SuccessModal';
import Tooltip from '../../../components/Common/tooltip/tooltip';

import {
  calculateMeasureTotal,
  calculateQuarterTotal,
  totalWeeksOfSelectedQuarter, checkIfAllQuartersArePast, calculateActualMeasureTotal,weekValue
} from './helper';
import {
  GetPlanId, getRatioSelectionOfPlanningGridForQuarter, getRatioSelectionOfPlanningGridForWeek,
  IsNegative,
  NumberWithCommas, OneDecimalPlace,
} from '../../../helpers/Helpers';

import { UpdateEditRestriction } from '../../../store/action-restriction/actions';
import HelpModal from '../../../components/Common/Modals/HelpModal';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
  onRunningEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isAutoLoad:boolean;
  isLoading: boolean;
  isExpanded: boolean;
  originalDataSource: IPlanningData;
  dataSource: IPlanningData;
  selectedColumn: string;
  initializeList: {
    label: string;
    value: string;
  }[];
  selectedInitialize: string;
  isMoreMenuOpened: boolean;
  isDownloadMenu: boolean;
  isEditable: boolean;
  isEditRestrictionAllowed: boolean;
  isVisibilityMenuOpened: boolean;
  measureVisibilityList: IMeasureVisibility;
  isModalOpened: boolean;
  isgoalSeekDisabled: boolean;
  isRunningModal: boolean;
  disableSave: boolean;
  successMessage: string;
  isInfoModalOpen: boolean;
}

class PlanningTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isAutoLoad: true,
      isLoading: false,
      isExpanded: true,
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] },
      selectedColumn: '',
      initializeList: [
        { label: 'Copy Sales to Rolling Plan', value: 'STRP' },
        { label: 'Copy ASP to Rolling Plan', value: 'ASP' },
        { label: 'Copy FORECAST to Rolling Plan', value: 'FORECAST' },
      ],
      selectedInitialize: '',
      isMoreMenuOpened: false,
      isDownloadMenu: false,
      isEditable: false,
      isEditRestrictionAllowed: false,
      isVisibilityMenuOpened: false,
      measureVisibilityList: { row: [] },
      isModalOpened: false,
      isgoalSeekDisabled: false,
      isRunningModal: false,
      disableSave: false,
      successMessage: '',
      isInfoModalOpen: false,
    };

    this.toggleMoreMenu = this.toggleMoreMenu.bind(this);
    this.toggleVisibilityMenu = this.toggleVisibilityMenu.bind(this);
    this.toggleDownloadMenu = this.toggleDownloadMenu.bind(this);
  }

  componentDidMount(): void {
    //this.getRollingPlanData();
    this.setState({ isLoading: false }); 
    this.props.onLoadEnd();
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.getRollingPlanData();
    }
  }

  getRollingPlanData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    GetRollingPlanData(params)
      .then((res: IPlanningData) => {
        this.setState({
          originalDataSource: !!res ? res : { columns: [], rows: [] },
          isLoading: false,isAutoLoad:false,
        }, () => {
          if (this.validateJSON()) {
            this.dataInit();
          }
          this.props.onLoadEnd();
          this.props.UpdateEditRestriction(false);
        });
      });
  }

  validateJSON(): boolean {
    const quarterLength = this.state.originalDataSource.columns.length;
    const weekLength = this.state.originalDataSource.columns.reduce((colInit, col) => {
      colInit += col.months.reduce((mInit, month) => {
        mInit += month.weeks.length;
        return mInit;
      }, 0);
      return colInit;
    }, 0);

    return this.state.originalDataSource.rows
      .reduce((rInit, row) => rInit && row.measures
        .reduce((mInit, measure) => mInit && measure.quarters.length === quarterLength && measure.quarters
          .reduce((qInit, quarter) => {
            qInit += quarter.weeks.length;
            return qInit;
          }, 0) === weekLength, true), true);
  }

  copyDataToPlan(): void {
    this.props.onUpdateStart();

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    CopyDataToPlan(this.state.selectedInitialize, params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
        this.setState({ selectedInitialize: '', 
          isModalOpened: true, 
          successMessage: 'Data copied to plan successfully !!'
         });
      });
  }

  freezePlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };
    
    this.props.onUpdateStart();

    FreezePlan(params)
      .then(() => {
        this.setState({
                isModalOpened: true, 
                successMessage: 'Your changes have been successfully saved and are now frozen.'
              });
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }

  goalSeek(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    GoalSeek(params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
        this.setState({
          isModalOpened: true, 
          successMessage: 'Goal Seek Completed.'
         });
      });
  }

  importTemplate = (event): void => {
    let formData = new FormData();
    formData.append('file', event.target['files'][0], event.target['files'][0].name);

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    ImportTemplate(formData, params)
      .then(() => {
        this.props.onUpdateEnd();
      });
  };

  downloadTemplate(type: string): void {
    this.setState({ isLoading: true });

    const params = {
      type,
      planId: GetPlanId(this.props.history.location.pathname) || 1,
      userId: sessionStorage.getItem('userName')
    };

    DownloadTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'units':
          filename = 'rolling_plan_units.xlsx';
          break;
        case 'revenue':
          filename = 'rolling_plan_revenue.xlsx';
          break;
        case 'frozen':
          filename = 'freeze_rolling_plan.xlsx';
          break;
      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  dataInit(): void {
    const data: IPlanningData = { ...this.state.originalDataSource };
    const dataSource: IPlanningData = {
      columns: data.columns.map((col) => ({
        ...col,
        isExpanded: col.isExpanded,
      })),
      rows: data.rows.map((row, rIdx: number) => ({
        ...row,
        measures: row.measures.map((measure, mIdx: number) => {
          const mVal = calculateMeasureTotal(data.rows, rIdx, mIdx, row.name, measure.name);
          return {
            ...measure,
            value: mVal,
            oldVal: mVal,
            isPast: checkIfAllQuartersArePast(measure.quarters),
            quarters: measure.quarters.map((quarter, qIdx: number) => {
              const qVal = calculateQuarterTotal(data.rows, rIdx, mIdx, qIdx, row.name, measure.name);
              return {
                ...quarter,
                isExpanded: data.columns[qIdx].isExpanded,
                isEdited: false,
                isChanged: false,
                isDisabled: false,
                value: qVal,
                oldVal: qVal,
                weeks: quarter.weeks.map((week, wIdx: number) => {
                  // Get the raw value using weekValue
                  const rawWValue = weekValue(
                    data.rows,
                    rIdx,
                    mIdx,
                    qIdx,
                    wIdx,
                    week,
                    row.name,
                    measure.name,
                    measure.datatype
                  );
                  // Apply formatting based on measure.datatype
                  const formattedWValue =
                    measure.datatype === 'number'
                      ? Math.round(rawWValue)
                      : measure.datatype === 'percentage'
                      ? OneDecimalPlace(rawWValue)
                      : Math.round(rawWValue);
    
                  return {
                    ...week,
                    oldVal: formattedWValue,
                    value: formattedWValue,
                  };
                })
              };
            })
          };
        })
      }))
    };

    const measureVisibilityList: IMeasureVisibility = {
      row: dataSource.rows.map((row) => {
        return {
          name: row.name,
          measures: row.measures.map((measure) => {
            return {
              name: measure.name,
              displayName: measure.displayName,
              isVisible: measure.isVisible,
              prevCheck: measure.isVisible
            };
          })
        };
      })
    };

    //Disable Goal Seek Value if 'Rolling Plan / Quota Frozen U' or 'Gap Unit To Be Accomadated' is Zero
    if (dataSource.rows.length !== 0) {
      const rowUnitIdx = dataSource.rows.findIndex((row) => row.name === 'UNITS');
      const rollingFreezeUIdx = dataSource.rows[rowUnitIdx].measures.findIndex((measure) => measure.name === 'Rolling Plan / Quota Frozen U');
      if (rollingFreezeUIdx > -1) {
        const rollingFreezeUVal = dataSource.rows[rowUnitIdx].measures[rollingFreezeUIdx].value;
        const gapUnitIdx = dataSource.rows[rowUnitIdx].measures.findIndex((measure) => measure.name === 'Gap Unit To Be Accomadated');
        const gapUnitVal = dataSource.rows[rowUnitIdx].measures[gapUnitIdx].value;
        if (rollingFreezeUVal == 0 || gapUnitVal == 0) {
          this.setState({ isgoalSeekDisabled: true })
        } else {
          this.setState({ isgoalSeekDisabled: false })
        }

        this.setState({ dataSource, measureVisibilityList });
      }
    }
  }

  toggleMoreMenu(): void {
    this.setState((prevState) => ({
      isMoreMenuOpened: !prevState.isMoreMenuOpened
    }));
  }

  toggleVisibilityMenu(): void {
    this.setState((prevState) => ({
      isVisibilityMenuOpened: !prevState.isVisibilityMenuOpened
    }));
  }

  toggleDownloadMenu(): void {
    this.setState((prevState) => ({
      isDownloadMenu: !prevState.isDownloadMenu
    }));
  }

  onExpandColumn(colIdx: number, isExpanded: boolean): void {
    const columns = [...this.state.dataSource.columns];
    const rows = [...this.state.dataSource.rows];

    columns.map((col, index) => col.isExpanded = (colIdx === index) ? !isExpanded : false);

    rows.forEach((row, rIdx: number) => {
      row.measures.forEach((measure, mIdx: number) => {
        columns.map((col, index) => {
          const qIdx = measure.quarters.findIndex((quarter) => quarter.name === columns[index].name);
          if (qIdx > -1 && index === colIdx) {
            rows[rIdx].measures[mIdx].quarters[qIdx].isExpanded = !rows[rIdx].measures[mIdx].quarters[qIdx].isExpanded;
          } else {
            rows[rIdx].measures[mIdx].quarters[qIdx].isExpanded = false;
          }
        });
      });
    });

    this.setState({ dataSource: this.state.dataSource });
  }

  isColumnExpanded(): boolean {
    return this.state.dataSource.columns.reduce((acc, col) => acc || col.isExpanded, false);
  }

  checkIfQuarterContainsZero(): boolean {
    const baseMeasureGroup = 'REVENUE ($)';
    const baseMeasure = 'Forecast Unconstrained $';
    const baseMeasureGroupIdx = this.state.dataSource.rows.findIndex((row) => row.name === baseMeasureGroup);

    if (baseMeasureGroupIdx > -1) {
      const baseMeasureIdx = this.state.dataSource.rows[baseMeasureGroupIdx].measures
        .findIndex((measure) => measure.name === baseMeasure);

      if (baseMeasureIdx > -1) {
        return this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx].quarters
          .reduce((acc, quarter) => acc || quarter.value === 0, false);
      }
    }

    return true;
  }

  onUpdateVisibilityCheck(rowIdx: number, measureIdx: number): void {
    this.state.measureVisibilityList.row[rowIdx].measures[measureIdx].isVisible =
      !this.state.measureVisibilityList.row[rowIdx].measures[measureIdx].isVisible;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isVisible =
      !this.state.dataSource.rows[rowIdx].measures[measureIdx].isVisible;

    this.setState({
      dataSource: this.state.dataSource,
      measureVisibilityList: this.state.measureVisibilityList
    });
  }

  checkVisibilitySaveButton(): boolean {
    return this.state.measureVisibilityList.row
      .every((row) => row.measures
        .every((measure) => measure.isVisible === measure.prevCheck));
  }

  updateMeasureCalculation(rowArr, rowIdx: number, measureIdx: number, measureGroup: string, event): void {
    // const baseMeasure = units === 'currency' ? 'Forecast Unconstrained $' : 'Forecast Unconstrained U';
    const baseMeasureGroup = 'REVENUE ($)';
    const baseMeasure = !this.checkIfQuarterContainsZero() ? 'Forecast Unconstrained $' : 'LY - Actuals $';
    let measureName = this.state.dataSource.rows[rowIdx].measures[measureIdx].name;

    const baseMeasureGroupIdx = this.state.dataSource.rows.findIndex((row) => row.name === baseMeasureGroup);

    const value = event.target.value;

    // Group indexes
    const unitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const revenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');

    // Unit's subgroup indexes
    const planUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota U');
    const planUnitAPUIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Rolling Plan AP U');
    const plVsFctUUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Plan vs Fcst Uncons U');
    const fctUUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Forecast Unconstrained U');
    // const plVsLyUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'PL vs LY U %');
    const lyActualUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'LY - Actuals U');
    const plVsLqUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ U %');
    const lqActualUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'LQ - Actuals U');

    // Revenue's subgroup indexes
    const planAspIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan ASP $');
    const planSalesValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const fctUValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Forecast Unconstrained $');
    // const planVsFcstUValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan vs Fcst Uncons $');
    const plVsLyValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'PL vs LY $ %');
    const lyActualValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'LY - Actuals $');
    // const plVsLqValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ $ %');
    const lqActualValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'LQ - Actuals $');

    // Margin's subgroup indexes
    const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
    const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');
    const plVsLyMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'PL vs LY Margin %');
    const lyMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'LY Margin %');
    const plVsLqMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ Margin %');
    const lqMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'LQ Margin %');

    // Unit's subgroup values
    let planUnitValue = parseInt(rowArr[unitIdx].measures[planUnitIdx].value);
    const fctUUnitValue = parseInt(rowArr[unitIdx].measures[fctUUnitIdx].value);
    // const plVsFctUUnitValue = parseInt(rowArr[unitIdx].measures[plVsFctUUnitIdx].value);
    const lyActualUnitValue = parseInt(rowArr[unitIdx].measures[lyActualUnitIdx].value);
    // const plVsLyUnitValue = parseInt(rowArr[unitIdx].measures[plVsLyUnitIdx].value);
    const lqActualUnitValue = parseInt(rowArr[unitIdx].measures[lqActualUnitIdx].value);
    // const plVsLqUnitValue = parseInt(rowArr[unitIdx].measures[plVsLqUnitIdx].value);

    // Revenue's subgroup values
    let planSalesValue = parseFloat(rowArr[revenueIdx].measures[planSalesValueIdx].value);
    let planAspValue = parseFloat(rowArr[revenueIdx].measures[planAspIdx].value);
    const fctUValue = parseFloat(rowArr[revenueIdx].measures[fctUValueIdx].value);
    // const planVsFcstUValue = parseFloat(rowArr[revenueIdx].measures[planVsFcstUValueIdx].value);
    const lyActualValue = parseFloat(rowArr[revenueIdx].measures[lyActualValueIdx].value);
    // const plVsLyValue = parseFloat(rowArr[revenueIdx].measures[plVsLyValueIdx].value);
    const lqActualValue = parseFloat(rowArr[revenueIdx].measures[lqActualValueIdx].value);
    // const plVsLqValue = parseFloat(rowArr[revenueIdx].measures[plVsLqValueIdx].value);

    // Margin's subgroup values
    const marginPctValue = parseFloat(rowArr[marginIdx].measures[marginPctIdx].value);
    let marginValue = parseFloat(rowArr[marginIdx].measures[marginValueIdx].value);
    const plVsLyMarginPctValue = parseFloat(rowArr[marginIdx].measures[plVsLyMarginPctIdx].value);
    const lyMarginPctValue = parseFloat(rowArr[marginIdx].measures[lyMarginPctIdx].value);
    const plVsLqMarginPctValue = parseFloat(rowArr[marginIdx].measures[plVsLqMarginPctIdx].value);
    const lqMarginPctValue = parseFloat(rowArr[marginIdx].measures[lqMarginPctIdx].value);

    // Units's subgroup isEdited value
    const isPlanUnitEdited = rowArr[unitIdx].measures[planUnitIdx].isEdited;

    // Revenue's subgroup isEdited value
    const isPlanAspEdited = rowArr[revenueIdx].measures[planAspIdx].isEdited;
    const isPlanValueEdited = rowArr[revenueIdx].measures[planSalesValueIdx].isEdited;

    // Margin's subgroup isEdited value
    const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

    const marginPctWholeGrandTotal = (rowArr[marginIdx].measures[marginValueIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].oldVal) * 100;
    const oldPlanSalesObj = JSON.parse(JSON.stringify(rowArr[revenueIdx].measures[planSalesValueIdx].quarters));
    const oldMarginValueObj = JSON.parse(JSON.stringify(rowArr[marginIdx].measures[marginValueIdx].quarters));

    this.state.dataSource.rows[rowIdx].measures[measureIdx].value = value;

    if(!measureName.includes('Rolling Plan AP U')){
      const isEdited = this.state.dataSource.rows[rowIdx].measures[measureIdx].value
      !== this.state.dataSource.rows[rowIdx].measures[measureIdx].oldVal;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = isEdited;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isChanged = true;

    }
    

    if (['Plan ASP', 'Margin %'].indexOf(measureName) !== -1) {
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value = parseFloat(value);
          quarter.isChanged = true;
        });
    } else {
      let baseMeasureIdx = -1;
      this.state.dataSource.rows.forEach((row) => {
        const idx = row.measures.findIndex((measure) => measure.name === baseMeasure);
        if (idx > -1) {
          baseMeasureIdx = idx;
        }
      });

      // New Grand Total Split Calculation
      if (measureName != 'Plan ASP $') {
        const pastQuarterTotal = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
          .filter((quarter) => quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        const editableQuarterTotal = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        if (value < pastQuarterTotal) {
          this.setState({ disableSave: true })
        } else {
          this.setState({ disableSave: false })
        }

        const remainingVal = value - pastQuarterTotal;
        this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
          .forEach((quarter, qIdx) => {
            if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
              quarter.value = Math.round((quarter.value / editableQuarterTotal) * remainingVal);
              this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
              this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[qIdx].isChanged = true;
            }
          });
      }
    }
    if(measureName.includes('Rolling Plan AP U')){
      measureName = 'Plan / Quota U';
      rowArr[unitIdx].measures[planUnitIdx].value = value;
      planUnitValue = value;

      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].isEdited=true
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].isDisabled=true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].isChanged=true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters
        .filter((quarter) => !quarter.isPast)
        .forEach((quarter) => {
          quarter.value = parseFloat(value);
          quarter.isChanged = true;
          quarter.isDisabled = true;
          quarter.isEdited = true;
        });
    }
    

    // Unit measures
    if (measureName === 'Plan / Quota U') {
      rowArr[revenueIdx].measures[planAspIdx].isDisabled = false;
      rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = false;

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      if (isPlanAspEdited) {
        rowArr[revenueIdx].measures[planAspIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = true;

        rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);

        const baseMeasureIdx = this.state.dataSource.rows[revenueIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[revenueIdx].measures[planSalesValueIdx].quarters
        // .filter((quarter) => !quarter.isPast)
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planUnitValue * planAspValue));
            quarter.isChanged = true;
          });

        if (!isMarginValueEdited) {
          rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
          rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
            const planQuotaValueQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
            const wholeMarginPctValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].quarters[qIdx].oldVal) * 100;
            quarter.value = Math.round(planQuotaValueQ * (wholeMarginPctValueQ / 100));
            quarter.isChanged = true;
          });
        }
      } else if (isPlanValueEdited) {
        rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);

        rowArr[revenueIdx].measures[planAspIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = false;
      } else {
        // Hold ASP and Calculate Sales on Unit Edit ---->GrandTotal

        //Quarter total Sales
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter, qIdx: number) => {
          const planQuotaValueQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
          const planAspValueV = rowArr[revenueIdx].measures[planAspIdx].quarters[qIdx].value;
          if (!quarter.isPast) {
            const wholeMarginPctValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].quarters[qIdx].oldVal) * 100;
            quarter.value = Math.round(planQuotaValueQ * planAspValueV);
            quarter.isChanged = true;
            //update margin$ Quarter
            rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].isChanged = true;
            rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].value = Math.round(quarter.value * (wholeMarginPctValueQ / 100));
          }
        });
        //GrandTotal Sales
        rowArr[revenueIdx].measures[planSalesValueIdx].value =
          rowArr[revenueIdx].measures[planSalesValueIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        // Recalculate ASP Value
        const salesTotalVal = rowArr[revenueIdx].measures[planSalesValueIdx].value;
        rowArr[revenueIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitValue);

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons U') {
      const measureValue = !!value ? parseInt(value) : 0;
      planUnitValue = measureValue + fctUUnitValue;
      rowArr[rowIdx].measures[planUnitIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);
      rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));

      rowArr[rowIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LY U %') {
      const measureValue = !!value ? parseInt(value) : 0;

      if (measureValue != 0) {
        planUnitValue = (1 + measureValue / 100) * lyActualUnitValue;
        rowArr[rowIdx].measures[planUnitIdx].value = Math.round(planUnitValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsLyValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LQ U %') {
      const measureValue = !!value ? parseInt(value) : 0;

      if (lqActualUnitValue != 0) {
        planUnitValue = (1 + measureValue / 100) * lqActualUnitValue;
        rowArr[rowIdx].measures[planUnitIdx].value = planUnitValue;
        rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsLqUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    // Revenue measures
    if (measureName === 'Plan ASP $') {
      planAspValue = !!value ? parseInt(value) : 0;

      rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
      rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = false;

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
        quarter.isChanged = false;
      });
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
        quarter.isChanged = true;
      });

      if (isPlanUnitEdited) {
        rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = true;

        const planUnitValue = parseFloat(rowArr[unitIdx].measures[planUnitIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        rowArr[revenueIdx].measures[planSalesValueIdx].value = planUnitValue * planAspValue;

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[revenueIdx].measures[planSalesValueIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planUnitValue * planAspValue));
            quarter.isChanged = true;
          });

        if (!isMarginValueEdited) {
          rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
          rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
            const oldPlanQuotaValueQ = oldPlanSalesObj[qIdx].oldVal;
            const oldMarginValueQ = oldMarginValueObj[qIdx].oldVal;
            const marginPctWholeValueQ = (oldMarginValueQ / oldPlanQuotaValueQ) * 100;
            quarter.value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
            quarter.isChanged = true;
          });
        }
      } else if (isPlanValueEdited) {
        rowArr[unitIdx].measures[planUnitIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = false;

        const planSalesValue = parseFloat(rowArr[revenueIdx].measures[planSalesValueIdx].value);
        const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        rowArr[unitIdx].measures[planUnitIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planSalesValue / planAspValue));
            quarter.isChanged = true;
            quarter.isDisabled = true;
          });
        //Update Quarter ASP
        rowArr[rowIdx].measures[measureIdx].quarters
          .forEach((quarter, qIdx) => {
            if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
              const unitValQ = rowArr[unitIdx].measures[planUnitIdx].quarters[qIdx].value;
              const salesValQ = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[qIdx].value;
              quarter.value = Math.round(salesValQ / unitValQ);
              rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
              rowArr[rowIdx].measures[measureIdx].quarters[qIdx].isChanged = true;
            }
          });
      } else {
        const planAspValue = parseFloat(rowArr[rowIdx].measures[measureIdx].value);
        const planUnitValue = parseFloat(rowArr[unitIdx].measures[planUnitIdx].value);
        rowArr[rowIdx].measures[planSalesValueIdx].value =
          planAspValue !== 0 ? Math.round(planUnitValue * planAspValue) : 0;

        //Split Sales Grandtotal
        const pastQuarterTotal = rowArr[revenueIdx].measures[planSalesValueIdx].quarters
          .filter((quarter) => quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        const editableQuarterTotal = rowArr[revenueIdx].measures[planSalesValueIdx].quarters
          .filter((quarter) => !quarter.isPast)
          .reduce((pastVal, qaurter) => {
            pastVal += qaurter.value;
            return pastVal;
          }, 0);

        const salesTotalVal = rowArr[revenueIdx].measures[planSalesValueIdx].value;
        if (salesTotalVal < pastQuarterTotal) {
          this.setState({ disableSave: true });
        } else {
          this.setState({ disableSave: false });

          const remainingVal = salesTotalVal - pastQuarterTotal;
          rowArr[revenueIdx].measures[planSalesValueIdx].quarters
            .forEach((quarter, qIdx) => {
              if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
                quarter.value = Math.round((quarter.value / editableQuarterTotal) * remainingVal);
                rowArr[revenueIdx].measures[planSalesValueIdx].quarters[qIdx].value = quarter.value;
                rowArr[revenueIdx].measures[planSalesValueIdx].quarters[qIdx].isChanged = true;
              }
            });

          //Update Quarter ASP
          rowArr[rowIdx].measures[measureIdx].quarters
            .forEach((quarter, qIdx) => {
              if (!quarter.isPast && (quarter.value || quarter.value === 0)) {
                const unitValQ = rowArr[unitIdx].measures[planUnitIdx].quarters[qIdx].value;
                const salesValQ = rowArr[rowIdx].measures[planSalesValueIdx].quarters[qIdx].value;
                quarter.value = Math.round(salesValQ / unitValQ);
                rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value = quarter.value;
                rowArr[rowIdx].measures[measureIdx].quarters[qIdx].isChanged = false;
                //update margin$ Quarter
                const oldPlanQuotaValueQ = oldPlanSalesObj[qIdx].oldVal;
                const oldMarginValueQ = oldMarginValueObj[qIdx].oldVal;
                const marginPctWholeValueQ = (oldMarginValueQ / oldPlanQuotaValueQ) * 100;
                rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].isChanged = true;
                rowArr[marginIdx].measures[marginValueIdx].quarters[qIdx].value = Math.round(salesValQ * (marginPctWholeValueQ / 100));
              }
            });
        }

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan / Quota Sales $') {
      planSalesValue = !!value ? parseInt(value) : 0;

      rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
      rowArr[revenueIdx].measures[planAspIdx].isDisabled = false;

      rowArr[rowIdx].measures[measureIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });

      if (!isMarginValueEdited) {
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
        rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
          const oldPlanQuotaValueQ = oldPlanSalesObj[qIdx].oldVal;
          const oldMarginValueQ = oldMarginValueObj[qIdx].oldVal;
          const marginPctWholeValueQ = (oldMarginValueQ / oldPlanQuotaValueQ) * 100;
          const planQuotaValueQ = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
          quarter.value = Math.round(planQuotaValueQ * (marginPctWholeValueQ / 100));
          quarter.isChanged = true;
        });
      }

      if (isPlanUnitEdited) {
        rowArr[revenueIdx].measures[planAspIdx].value =
          planUnitValue !== 0 ? Math.round(planSalesValue / planUnitValue) : 0;

        rowArr[unitIdx].measures[planUnitIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planAspIdx].isDisabled = true;
      } else if (isPlanAspEdited) {
        rowArr[unitIdx].measures[planUnitIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planAspIdx].isDisabled = false;

        rowArr[unitIdx].measures[planUnitIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;

        const baseMeasureIdx = this.state.dataSource.rows[rowIdx].measures
          .findIndex((measure) => measure.name === baseMeasure);

        this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters
          .forEach((quarter, qIdx: number) => {
            const measureData = this.state.dataSource.rows[baseMeasureGroupIdx].measures[baseMeasureIdx];
            const baseMeasureQuarter = measureData.quarters[qIdx].value || 0;
            const baseMeasureTotal = measureData.value || 0;

            quarter.value = Math.round((baseMeasureQuarter / baseMeasureTotal) * (planSalesValue / planAspValue));
            quarter.isChanged = true;
            quarter.isDisabled = true;
          });
        this.state.dataSource.rows[revenueIdx].measures[planAspIdx].quarters
          .forEach((quarter) => {
            quarter.isChanged = false;
            quarter.isDisabled = true;
          });
      } else {
        //Hold ASP and calculate Units on Sales Edit ----> GrandTotal
        //Quarter Total Unit
        rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter, qIdx: number) => {
          const planQuotaValueQ1 = rowArr[rowIdx].measures[measureIdx].quarters[qIdx].value;
          const planASPValue1 = rowArr[revenueIdx].measures[planAspIdx].quarters[qIdx].value;
          if (!quarter.isPast) {
            quarter.value = planASPValue1 !== 0 ? Math.round(planQuotaValueQ1 / planASPValue1) : 0;
            quarter.isChanged = true;
          }
        });

        //GrandTotal Units
        rowArr[unitIdx].measures[planUnitIdx].value =
          rowArr[unitIdx].measures[planUnitIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        // Recalculate ASP Value
        const salesTotalVal = rowArr[rowIdx].measures[measureIdx].value;
        const planUnitVal = rowArr[unitIdx].measures[planUnitIdx].value;
        rowArr[revenueIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitVal);

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons $') {
      const measureValue = !!value ? parseFloat(value) : 0;

      planSalesValue = measureValue + fctUValue;
      rowArr[rowIdx].measures[planSalesValueIdx].value = planSalesValue;
      rowArr[unitIdx].measures[planUnitIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));

      rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LY $ %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      if (lyActualValue != 0) {
        planSalesValue = (1 + measureValue / 100) * lyActualValue;
        rowArr[rowIdx].measures[planSalesValueIdx].value = Math.round(planSalesValue);
        rowArr[unitIdx].measures[planUnitIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsLyValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LQ $ %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      if (lqActualValue != 0) {
        planSalesValue = (1 + measureValue / 100) * lqActualValue;
        rowArr[rowIdx].measures[planSalesValueIdx].value = Math.round(planSalesValue);
        rowArr[unitIdx].measures[planUnitIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[marginIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsLyValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    // Margin measures
    if (measureName === 'Margin %') {
      rowArr[rowIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctValue / 100));

      rowArr[rowIdx].measures[marginValueIdx].isDisabled = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters.forEach((quarter, qIdx: number) => {
        const planQuotaValueQ = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[qIdx].value;
        const marginPctQ = rowArr[rowIdx].measures[marginValueIdx].quarters[qIdx].value;
        quarter.value = Math.round(planQuotaValueQ * (marginPctQ / 100));
        quarter.isChanged = true;
        quarter.isDisabled = true;
      });

      rowArr[rowIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
        quarter.isDisabled = true;
      });
    }

    if (measureName === 'Margin $') {
      rowArr[rowIdx].measures[marginPctIdx].isDisabled = true;
      rowArr[rowIdx].measures[marginPctIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
      rowArr[rowIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isDisabled = true;
      });
    }

    if (measureName === 'PL vs LY Margin %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      marginValue = (planSalesValue * (measureValue + lyMarginPctValue)) / 100;
      rowArr[rowIdx].measures[marginValueIdx].value = Math.round(marginValue);
      rowArr[rowIdx].measures[marginPctIdx].value = Math.round(plVsLyMarginPctValue + lyMarginPctValue);
      planUnitValue = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[unitIdx].measures[planUnitIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);

      rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    if (measureName === 'PL vs LQ Margin %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      marginValue = (planSalesValue * (measureValue + lqMarginPctValue)) / 100;
      rowArr[rowIdx].measures[marginValueIdx].value = Math.round(marginValue);
      rowArr[rowIdx].measures[marginPctIdx].value = Math.round(plVsLqMarginPctValue + lqMarginPctValue);
      planUnitValue = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[unitIdx].measures[planUnitIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);

      rowArr[unitIdx].measures[planUnitIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[marginValueIdx].quarters.forEach((quarter) => {
        quarter.isChanged = true;
      });
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters.forEach((quarter) => {
        quarter.isChanged = false;
      });
    }

    this.state.dataSource.rows[rowIdx].measures[marginValueIdx].quarters
      .filter((quarter) => !quarter.isPast)
      .forEach((quarter, qIdx) => {
        event.target.value = this.state.dataSource.rows[rowIdx].measures[marginValueIdx].quarters[qIdx].value;
        // this.updateQuarterCalculation(rowArr, rowIdx, measureIdx, qIdx, measureGroup, measureName, event)
      });

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateQuarterCalculation(
    rowArr,
    rowIdx: number,
    measureIdx: number,
    quarterIdx: number,
    measureGroup: string,
    measureName: string,
    event
  ): void {debugger;
    const value = event.target.value;

    // Group indexes
    const unitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const revenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');

    // Unit's subgroup indexes
    const planUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota U');
    const planUnitAPUIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Rolling Plan AP U');
    const plVsFctUUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Plan vs Fcst Uncons U');
    const fctUUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Forecast Unconstrained U');
    // const plVsLyUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'PL vs LY U %');
    const lyActualUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'LY - Actuals U');
    const plVsLqUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ U %');
    const lqActualUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'LQ - Actuals U');

    // Revenue's subgroup indexes
    const planAspIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan ASP $');
    const planSalesValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const fctUValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Forecast Unconstrained $');
    const plVsLyValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'PL vs LY $ %');
    const lyActualValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'LY - Actuals $');
    // const plVsLqValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ $ %');
    const lqActualValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'LQ - Actuals $');

    // Margin's subgroup indexes
    const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
    const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');
    const plVsLyMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'PL vs LY Margin %');
    const lyMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'LY Margin %');
    const plVsLqMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ Margin %');
    const lqMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'LQ Margin %');

    // Unit's subgroup values
    let planUnitValue = parseInt(rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value);
    const fctUUnitValue = parseInt(rowArr[unitIdx].measures[fctUUnitIdx].quarters[quarterIdx].value);
    // const plVsFctUUnitValue = parseInt(rowArr[unitIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].value);
    const lyActualUnitValue = parseInt(rowArr[unitIdx].measures[lyActualUnitIdx].quarters[quarterIdx].value);
    // const plVsLyUnitValue = parseInt(rowArr[unitIdx].measures[plVsLyUnitIdx].quarters[quarterIdx].value);
    const lqActualUnitValue = parseInt(rowArr[unitIdx].measures[lqActualUnitIdx].quarters[quarterIdx].value);
    // const plVsLqUnitValue = parseInt(rowArr[unitIdx].measures[plVsLqUnitIdx].quarters[quarterIdx].value);

    // Revenue's subgroup values
    let planSalesValue = parseFloat(rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value);
    let planAspValue = parseFloat(rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].value);
    const fctUValue = parseFloat(rowArr[revenueIdx].measures[fctUValueIdx].quarters[quarterIdx].value);
    const lyActualValue = parseFloat(rowArr[revenueIdx].measures[lyActualValueIdx].quarters[quarterIdx].value);
    // const plVsLyValue = parseFloat(rowArr[revenueIdx].measures[plVsLyValueIdx].quarters[quarterIdx].value);
    const lqActualValue = parseFloat(rowArr[revenueIdx].measures[lqActualValueIdx].quarters[quarterIdx].value);
    // const plVsLqValue = parseFloat(rowArr[revenueIdx].measures[plVsLqValueIdx].quarters[quarterIdx].value);

    // Margin's subgroup values
    const marginPctValue = parseFloat(rowArr[marginIdx].measures[marginPctIdx].quarters[quarterIdx].value);
    let marginValue = parseFloat(rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value);
    const plVsLyMarginPctValue = parseFloat(rowArr[marginIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].value);
    const lyMarginPctValue = parseFloat(rowArr[marginIdx].measures[lyMarginPctIdx].quarters[quarterIdx].value);
    const plVsLqMarginPctValue = parseFloat(rowArr[marginIdx].measures[plVsLqMarginPctIdx].quarters[quarterIdx].value);
    const lqMarginPctValue = parseFloat(rowArr[marginIdx].measures[lqMarginPctIdx].quarters[quarterIdx].value);

    // Units's subgroup isEdited value
    const isPlanUnitEdited = rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isEdited;

    // Revenue's subgroup isEdited value
    const isPlanAspEdited = rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isEdited;
    const isPlanValueEdited = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isEdited;

    // Margin's subgroup isEdited value
    const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

    const marginPctWholeValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].oldVal) * 100;
    const marginPctWholeGrandTotal = (rowArr[marginIdx].measures[marginValueIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].oldVal) * 100;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value = value;

    if(!measureName.includes('Rolling Plan AP U')){
      const isEdited = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value
      !== this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].oldVal;

      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isEdited = isEdited;
      this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = isEdited;
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;
    }
    

    this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters
      //.filter((quarter) => !quarter.isPast)
        .reduce((acc, quarter) => {
          acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
          return acc;
        }, 0);

    
    if(measureName.includes('Rolling Plan AP U')){
      measureName = 'Plan / Quota U';
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value = value;
      planUnitValue = value;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isEdited = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = true;

      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isEdited = true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].isEdited = true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;     
    }
    
//Editing Based on Reverse Formula Calculation
    // UNIT Measures
    if (measureName === 'Plan / Quota U') {
      rowArr[rowIdx].measures[measureIdx].isDisabled = true;
      rowArr[revenueIdx].measures[planAspIdx].isDisabled = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = true;

      if (isPlanAspEdited) {
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value =
          Math.round(planUnitValue * planAspValue);

        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isDisabled = true;

        if (!isMarginValueEdited) {
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
        }
      } else if (isPlanValueEdited) {
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isDisabled = false;
      } else {
        //Hold ASP and Calculate Sales on Unit Edit ---->Quarter Level
        //Update Quarter Sales
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value =
          Math.round(value * planAspValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;

        //Update Sales GrandTotal
        rowArr[revenueIdx].measures[planSalesValueIdx].value =
          rowArr[revenueIdx].measures[planSalesValueIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        //Update Margin$ Value
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));

        //Update Margin$ Grand total
        const salesGrandTotal = rowArr[revenueIdx].measures[planSalesValueIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesGrandTotal * (marginPctWholeGrandTotal / 100));

        //Recalculate ASP
        const planUnitTotal = rowArr[rowIdx].measures[measureIdx].value;
        rowArr[revenueIdx].measures[planAspIdx].value = Math.round(salesGrandTotal / planUnitTotal);
      }
    }

    if (measureName === 'Plan vs Fcst Uncons U') {
      const measureValue = !!value ? parseInt(value) : 0;
      planUnitValue = measureValue + fctUUnitValue;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = Math.round(planUnitValue * planAspValue);
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY U %') {
      const measureValue = !!value ? parseInt(value) : 0;

      if (measureValue != 0) {
        planUnitValue = (1 + measureValue / 100) * lyActualUnitValue;
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].value = Math.round(planUnitValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ U %') {
      const measureValue = !!value ? parseInt(value) : 0;

      if (lqActualUnitValue != 0) {
        planUnitValue = (1 + measureValue / 100) * lqActualUnitValue;
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].value = planUnitValue;
        rowArr[revenueIdx].measures[planSalesValueIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLqUnitIdx].quarters[quarterIdx].isChanged = false;
    }

    // Revenue measures
    if (measureName === 'Plan ASP $') {
      planAspValue = !!value ? parseInt(value) : 0;

      rowArr[rowIdx].measures[measureIdx].isDisabled = true;
      rowArr[unitIdx].measures[planUnitIdx].isDisabled = true;
      rowArr[unitIdx].measures[planUnitAPUIdx].isDisabled = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].isDisabled = true;

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;

      if (isPlanUnitEdited) {
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;

        rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = (planUnitValue * planAspValue);

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[unitIdx].measures[planUnitAPUIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isDisabled = true;

        if (!isMarginValueEdited) {
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
        }
      } else if (isPlanValueEdited) {
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isDisabled = false;
      } else {
        //Hold Unit and Calculate Sales on ASP Edit---->Quarter Level
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = (planUnitValue * planAspValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;
        //Update Sales GrandTotal
        rowArr[revenueIdx].measures[planSalesValueIdx].value =
          rowArr[revenueIdx].measures[planSalesValueIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        //Update Margin$
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));

        //Update Margin$ grandTotal
        const salesGrandTotal = rowArr[revenueIdx].measures[planSalesValueIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesGrandTotal * (marginPctWholeGrandTotal / 100));

        // Update ASP GrandTotal
        const planUnitGrandTotal = rowArr[unitIdx].measures[planUnitIdx].value;
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesGrandTotal / planUnitGrandTotal);
      }
    }

    if (measureName === 'Plan / Quota Sales $') {
      planSalesValue = !!value ? parseInt(value) : 0;

      rowArr[rowIdx].measures[measureIdx].isDisabled = true;
      rowArr[unitIdx].measures[planUnitIdx].isDisabled = true;
      rowArr[revenueIdx].measures[planAspIdx].isDisabled = true;

      if (!isMarginValueEdited) {
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
      }

      if (isPlanUnitEdited) {
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].value =
          planUnitValue !== 0 ? Math.round(planSalesValue / planUnitValue) : 0;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = true;
      } else if (isPlanAspEdited) {
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isDisabled = false;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isChanged = false;
      } else {
        //Hold ASP and Calculate Units on Sales Edit -->Quarter Level
        //Quarter unit
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;

        //Plan Unit GrandTotal
        rowArr[unitIdx].measures[planUnitIdx].value =
          rowArr[unitIdx].measures[planUnitIdx].quarters
            .reduce((acc, quarter) => {
              acc += typeof quarter.value === 'string' ? parseFloat(quarter.value) : quarter.value;
              return acc;
            }, 0);

        //Recalculate ASP
        const salesTotalVal = rowArr[rowIdx].measures[measureIdx].value;
        const planUnitTotal = rowArr[unitIdx].measures[planUnitIdx].value;
        rowArr[revenueIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitTotal);

        //Update Margin$ grandTotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons $') {
      const measureValue = !!value ? parseFloat(value) : 0;

      planSalesValue = measureValue + fctUValue;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = planSalesValue;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY $ %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      if (lyActualValue != 0) {
        planSalesValue = (1 + measureValue / 100) * lyActualValue;
        rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue);
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ $ %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      if (lqActualValue != 0) {
        planSalesValue = (1 + measureValue / 100) * lqActualValue;
        rowArr[rowIdx].measures[planSalesValueIdx].value = Math.round(planSalesValue);
        rowArr[unitIdx].measures[planUnitIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLyValueIdx].quarters[quarterIdx].isChanged = false;
    }

    // Margin measures
    if (measureName === 'Margin %') {
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round((marginPctValue * planSalesValue) / 100);

      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value =
        (
          this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value /
          this.state.dataSource.rows[rowIdx].measures[marginValueIdx].quarters.length
        );

      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY Margin %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      marginValue = (planSalesValue * (measureValue + lyMarginPctValue)) / 100;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(marginValue);
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].value = Math.round(plVsLyMarginPctValue + lyMarginPctValue);
      planUnitValue = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = Math.round(planUnitValue * planAspValue);

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ Margin %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      marginValue = (planSalesValue * (measureValue + lqMarginPctValue)) / 100;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(marginValue);
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].value = Math.round(plVsLqMarginPctValue + lqMarginPctValue);
      planUnitValue = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value = Math.round(planUnitValue * planAspValue);

      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLqMarginPctIdx].quarters[quarterIdx].isChanged = false;
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateWeekCalculation(
    rowArr,
    rowIdx: number,
    measureIdx: number,
    quarterIdx: number,
    weekIdx: number,
    measureGroup,
    event
  ): void {debugger;
    const value = event.target.value;
    let measureName = this.state.dataSource.rows[rowIdx].measures[measureIdx].name;

    // Group indexes
    const unitIdx = rowArr.findIndex((row) => row.name === 'UNITS');
    const revenueIdx = rowArr.findIndex((row) => row.name === 'REVENUE ($)');
    const marginIdx = rowArr.findIndex((row) => row.name === 'MARGIN %');

    // Unit's subgroup indexes
    const planUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota U');
    const planUnitAPUIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Rolling Plan AP U');
    const plVsFctUUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Plan vs Fcst Uncons U');
    const fctUUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'Forecast Unconstrained U');
    // const plVsLyUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'PL vs LY U %');
    const lyActualUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'LY - Actuals U');
    const plVsLqUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ U %');
    const lqActualUnitIdx = rowArr[unitIdx].measures.findIndex((measure) => measure.name === 'LQ - Actuals U');

    // Revenue's subgroup indexes
    const planAspIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan ASP $');
    const planSalesValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota Sales $');
    const fctUValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'Forecast Unconstrained $');
    // const plVsLyValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'PL vs LY $ %');
    const lyActualValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'LY - Actuals $');
    // const plVsLqValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ $ %');
    const lqActualValueIdx = rowArr[revenueIdx].measures.findIndex((measure) => measure.name === 'LQ - Actuals $');

    // Margin's subgroup indexes
    const marginValueIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin $');
    const marginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'Margin %');
    const plVsLyMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'PL vs LY Margin %');
    const lyMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'LY Margin %');
    const plVsLqMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'PL vs LQ Margin %');
    const lqMarginPctIdx = rowArr[marginIdx].measures.findIndex((measure) => measure.name === 'LQ Margin %');

    if(measureName.includes('Rolling Plan AP U')){
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = value;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isEdited = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].isEdited = true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isEdited = true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
    }
    // Unit's subgroup values
    let planUnitValue = parseInt(rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const fctUUnitValue = parseInt(rowArr[unitIdx].measures[fctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
    // const plVsFctUUnitValue = parseInt(rowArr[unitIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const lyActualUnitValue = parseInt(rowArr[unitIdx].measures[lyActualUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
    // const plVsLyUnitValue = parseInt(rowArr[unitIdx].measures[plVsLyUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const lqActualUnitValue = parseInt(rowArr[unitIdx].measures[lqActualUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
    // const plVsLqUnitValue = parseInt(rowArr[unitIdx].measures[plVsLqUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);

    // Revenue's subgroup values
    let planSalesValue = parseFloat(rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value);
    let planAspValue = parseFloat(rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const fctUValue = parseFloat(rowArr[revenueIdx].measures[fctUValueIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const lyActualValue = parseFloat(rowArr[revenueIdx].measures[lyActualValueIdx].quarters[quarterIdx].weeks[weekIdx].value);
    // const plVsLyValue = parseFloat(rowArr[revenueIdx].measures[plVsLyValueIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const lqActualValue = parseFloat(rowArr[revenueIdx].measures[lqActualValueIdx].quarters[quarterIdx].weeks[weekIdx].value);
    // const plVsLqValue = parseFloat(rowArr[revenueIdx].measures[plVsLqValueIdx].quarters[quarterIdx].weeks[weekIdx].value);

    // Margin's subgroup values
    const marginPctValue = parseFloat(rowArr[marginIdx].measures[marginPctIdx].quarters[quarterIdx].weeks[weekIdx].value);
    let marginValue = parseFloat(rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const plVsLyMarginPctValue = parseFloat(rowArr[marginIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const lyMarginPctValue = parseFloat(rowArr[marginIdx].measures[lyMarginPctIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const plVsLqMarginPctValue = parseFloat(rowArr[marginIdx].measures[plVsLqMarginPctIdx].quarters[quarterIdx].weeks[weekIdx].value);
    const lqMarginPctValue = parseFloat(rowArr[marginIdx].measures[lqMarginPctIdx].quarters[quarterIdx].weeks[weekIdx].value);

    // Units's subgroup isEdited value
    const isPlanUnitEdited = rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

    // Revenue's subgroup isEdited value
    const isPlanAspEdited = rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;
    const isPlanValueEdited = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isEdited;

    // Margin's subgroup isEdited value
    const isMarginValueEdited = rowArr[marginIdx].measures[marginValueIdx].isEdited;

    const marginPctWholeValueW = (rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].oldVal) * 100;
    const marginPctWholeValueQ = (rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].oldVal) * 100;
    const marginPctWholeGrandTotal = (rowArr[marginIdx].measures[marginValueIdx].oldVal / rowArr[revenueIdx].measures[planSalesValueIdx].oldVal) * 100;

    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks[weekIdx].value = value;
    
    if(!measureName.includes('Rolling Plan AP U')){
      const isEdited = this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks[weekIdx].value
      !== this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks[weekIdx].oldVal;

      this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = isEdited;
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks[weekIdx].isEdited = isEdited;
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;
    }else{
      measureName = 'Plan / Quota U';
    }
    
    this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value =
      Math.round(this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks
        .reduce((acc, week) => {
          acc += typeof week.value === 'string' ? parseFloat(week.value) : week.value;
          return acc;
        }, 0));

    this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
      Math.round(this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters.reduce((acc, quarter) => {
        acc += quarter.value;
        return acc;
      }, 0));

    if (measureName.includes('Plan ASP')) {
      this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value =
        (
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].value /
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks.length
        );
      this.state.dataSource.rows[rowIdx].measures[measureIdx].value =
        (
          this.state.dataSource.rows[rowIdx].measures[measureIdx].value /
          this.state.dataSource.rows[rowIdx].measures[measureIdx].quarters.length
        );
    }

    // UNIT Measures
    if (measureName === 'Plan / Quota U') {
      if (isPlanAspEdited) {
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value =
          Math.round(planUnitValue * planAspValue);

        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        if (!isMarginValueEdited) {
          const planSalesValue = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueW / 100));
        }

        this.state.dataSource.rows[rowIdx].measures[planAspIdx].quarters[quarterIdx].isChanged = false;
      } else if (isPlanValueEdited) {
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].value =
          Math.round(planSalesValue / planUnitValue);

        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = false;
      } else {
        //Hold ASP and Calculate sales on Unit Edit - Week Level
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value =
          Math.round(value * planAspValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

        //Sales Quarter GrandTotal
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value =
          Math.round(rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks
            .reduce((acc, week) => {
              acc += typeof week.value === 'string' ? parseFloat(week.value) : week.value;
              return acc;
            }, 0));

        //Final Sales GrandTotal
        rowArr[revenueIdx].measures[planSalesValueIdx].value =
          Math.round(rowArr[revenueIdx].measures[planSalesValueIdx].quarters.reduce((acc, quarter) => {
            acc += quarter.value;
            return acc;
          }, 0));

        //Recalculate ASP QuarterTotal
        const salesTotalValQ = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value;
        const planUnitTotalQ = rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ / planUnitTotalQ);

        //Recalculate ASP GrandTotal
        const salesTotalVal = rowArr[revenueIdx].measures[planSalesValueIdx].value;
        const planUnitTotal = rowArr[rowIdx].measures[measureIdx].value;
        rowArr[revenueIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitTotal);

        //Update Margin$ week
        const planQuotaWeek = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planQuotaWeek * (marginPctWholeValueW / 100));

        //Update Margin$ Quarter
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ * (marginPctWholeValueQ / 100));

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons U') {
      const measureValue = !!value ? parseInt(value) : 0;
      planUnitValue = measureValue + fctUUnitValue;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue);
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue * planAspValue);
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY U %') {
      const measureValue = !!value ? parseInt(value) : 0;

      if (measureValue != 0) {
        planUnitValue = (1 + measureValue / 100) * lyActualUnitValue;
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ U %') {
      const measureValue = !!value ? parseInt(value) : 0;

      if (lqActualUnitValue != 0) {
        planUnitValue = (1 + measureValue / 100) * lqActualUnitValue;
        rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = planUnitValue;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));
      }

      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLqUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsLqUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    // Revenue
    if (measureName === 'Plan ASP $') {
      planAspValue = !!value ? parseInt(value) : 0;

      rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

      if (isPlanUnitEdited) {
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

        planUnitValue = parseFloat(rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = (planUnitValue * planAspValue);

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = false;
        rowArr[unitIdx].measures[planUnitAPUIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isDisabled = true;

        if (!isMarginValueEdited) {
          const planSalesValue = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value;
          rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueW / 100));
        }

        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;
      } else if (isPlanValueEdited) {
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = false;

        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      } else {
        //Hold Unit and Calculate Sales on ASP Edit ---->Week Calculation
        const planUnitValue = rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue * planAspValue);
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].isChanged = false;

        //Sales Quarter GrandTotal
        rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].value =
          Math.round(rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks
            .reduce((acc, week) => {
              acc += typeof week.value === 'string' ? parseFloat(week.value) : week.value;
              return acc;
            }, 0));

        //Final Sales GrandTotal
        rowArr[revenueIdx].measures[planSalesValueIdx].value =
          Math.round(rowArr[revenueIdx].measures[planSalesValueIdx].quarters.reduce((acc, quarter) => {
            acc += quarter.value;
            return acc;
          }, 0));

        // Update ASP GrandTotal
        const salesGrandTotal = rowArr[revenueIdx].measures[planSalesValueIdx].value;
        const planUnitGrandTotal = rowArr[unitIdx].measures[planUnitIdx].value;
        const planAspIdx = rowArr[revenueIdx].measures
          .findIndex((measure) => rowArr[revenueIdx].name === measureGroup && measure.name === 'Plan ASP $');
        rowArr[revenueIdx].measures[planAspIdx].value = Math.round(salesGrandTotal / planUnitGrandTotal);

        // Update ASP Quarter GrandTotal
        const salesGrandTotalQ = rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].value;
        const planUnitGrandTotalQ = rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value = Math.round(salesGrandTotalQ / planUnitGrandTotalQ);

        //Update Margin$ Week
        const planQuotaWeek = rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planQuotaWeek * (marginPctWholeValueW / 100));

        //Update Margin$ Quarter
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(salesGrandTotalQ * (marginPctWholeValueQ / 100));

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesGrandTotal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan / Quota Sales $') {
      planSalesValue = !!value ? parseInt(value) : 0;

      if (!isMarginValueEdited) {
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueW / 100));
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      }
      if (isPlanUnitEdited) {
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planUnitValue !== 0 ? Math.round(planSalesValue / planUnitValue) : 0;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = false;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
      } else if (isPlanAspEdited) {
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = true;
        rowArr[revenueIdx].measures[planAspIdx].quarters[quarterIdx].weeks[weekIdx].isDisabled = false;

        this.state.dataSource.rows[revenueIdx].measures[planAspIdx].quarters[quarterIdx].isChanged = false;
        this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        this.state.dataSource.rows[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isDisabled = true;
      } else {
        // Hold ASP and Calculate Units on Sales Edit ---> Week Calculation
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value =
          planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;

        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
        //Hold ASP and Update Quarter GrandTotal of Units
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value =
          Math.round(rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks
            .reduce((acc, week) => {
              acc += typeof week.value === 'string' ? parseFloat(week.value) : week.value;
              return acc;
            }, 0));

        //Update Final GrandTotal of Units
        rowArr[unitIdx].measures[planUnitIdx].value =
          Math.round(rowArr[unitIdx].measures[planUnitIdx].quarters.reduce((acc, quarter) => {
            acc += quarter.value;
            return acc;
          }, 0));

        //Recalculate ASP QuarterTotal
        const salesTotalValQ = rowArr[rowIdx].measures[measureIdx].quarters[quarterIdx].value;
        const planUnitTotalQ = rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].value;
        rowArr[rowIdx].measures[planAspIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ / planUnitTotalQ);
        //Recalculate ASP GrandTotal
        const salesTotalVal = rowArr[rowIdx].measures[measureIdx].value;
        const planUnitTotal = rowArr[unitIdx].measures[planUnitIdx].value;
        rowArr[rowIdx].measures[planAspIdx].value = Math.round(salesTotalVal / planUnitTotal);

        //Update Margin$ Quarter
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].value = Math.round(salesTotalValQ * (marginPctWholeValueQ / 100));

        //Update Margin$ Grandtotal
        rowArr[marginIdx].measures[marginValueIdx].value = Math.round(salesTotalVal * (marginPctWholeGrandTotal / 100));
      }
    }

    if (measureName === 'Plan vs Fcst Uncons $') {
      const measureValue = !!value ? parseFloat(value) : 0;

      planSalesValue = measureValue + fctUValue;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = planSalesValue;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeValueQ / 100));

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY $ %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      if (lyActualValue != 0) {
        planSalesValue = (1 + measureValue / 100) * lyActualValue;
        rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue);
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ $ %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      if (lqActualValue != 0) {
        planSalesValue = (1 + measureValue / 100) * lqActualValue;
        rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue);
        rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
        rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planSalesValue * (marginPctWholeGrandTotal / 100));
      }

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[marginIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsFctUUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    // Margin measures
    if (measureName === 'Margin %') {
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round((value * planSalesValue) / 100);

      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    if (measureName === 'PL vs LY Margin %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      marginValue = (planSalesValue * (measureValue + lyMarginPctValue)) / 100;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(marginValue);
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(plVsLyMarginPctValue + lyMarginPctValue);
      planUnitValue = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue * planAspValue);

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    if (measureName === 'PL vs LQ Margin %') {
      const measureValue = !!value ? parseFloat(value) : 0;

      marginValue = (planSalesValue * (measureValue + lqMarginPctValue)) / 100;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(marginValue);
      rowArr[rowIdx].measures[marginPctIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(plVsLqMarginPctValue + lqMarginPctValue);
      planUnitValue = planAspValue !== 0 ? Math.round(planSalesValue / planAspValue) : 0;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].value = planUnitValue;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].value = Math.round(planUnitValue * planAspValue);

      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].isChanged = true;
      rowArr[unitIdx].measures[planUnitIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[revenueIdx].measures[planSalesValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].isChanged = true;
      rowArr[rowIdx].measures[marginValueIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = true;
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].isChanged = false;
      rowArr[rowIdx].measures[plVsLyMarginPctIdx].quarters[quarterIdx].weeks[weekIdx].isChanged = false;
    }

    this.props.UpdateEditRestriction(true);
    this.setState({ dataSource: this.state.dataSource });
  }

  updateRollingPlanData(isFreezeRequired: boolean): void {
    const payload: IPlanningPayload = { row: [] };

    const isQuarterExpanded = !!this.state.dataSource.rows
      .filter((row) => !!row.measures
        .filter((measure) => !!measure.quarters
          .filter((quarter) => quarter.isExpanded).length).length).length;

    payload.row = this.state.dataSource.rows
      .filter((row) => row.measures
        .filter((measure) => !!measure.quarters
          .filter((quarter) => quarter.isChanged).length).length)
      .map((row) => {
        return {
          name: row.name,
          measures: row.measures
            .filter((measure) => !!measure.quarters
              .filter((quarter) => quarter.isChanged).length)
            .map((measure) => {
              return {
                name: measure.name,
                quarters: measure.quarters
                  .filter((quarter) => quarter.isChanged)
                  .map((quarter, qIdx: number) => {
                    const quarterPayload: any = {
                      name: quarter.name
                    };
                    if (isQuarterExpanded) {
                      quarterPayload.weeks = quarter.weeks
                        .filter((week) => week.isChanged)
                        .map((week, wIdx: number) => {
                          return {
                            name: week.name,
                            value: week.value,
                            ratioSelection:
                              getRatioSelectionOfPlanningGridForWeek(this.state.dataSource.rows, qIdx, wIdx, week.oldVal),
                          };
                        });
                    } else {
                      quarterPayload.value = quarter.value;
                      quarterPayload.ratioSelection =
                        getRatioSelectionOfPlanningGridForQuarter(this.state.dataSource.rows, qIdx, quarter.oldVal,false);
                    }
                    return quarterPayload;
                  })
              };
            })
        };
      });

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    // debugger;

    this.props.onUpdateStart();

    UpdateRollingPlanData(payload, params)
      .then((res) => {
        if (!!res && res != 'running') {
          this.setState({
            isEditable: false
          }, () => {
            if (isFreezeRequired) {
              this.freezePlan();
            } else {
              this.props.onUpdateEnd();
              this.props.UpdateEditRestriction(false);
            }
          });
        } else if (!!res && res === 'running') {
          this.setState({ isRunningModal: true });
          this.props.onLoadEnd();
          this.props.onRunningEnd();
          this.setState({
            isEditable: false
          }, () => {
            this.dataInit();
          });
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  updateMeasureVisibility(): void {
    const payload: IMeasureVisibilityPayload = {
      visibility: this.state.measureVisibilityList.row
        .flatMap((row) => row.measures
          .map((measure) => ({
              name: measure.name,
              isVisible: measure.isVisible
            })
          )
        )
    };
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    UpdateMeasureVisibility(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            isLoading: true,
            isModalOpened: true,
            successMessage:'Measure visibility updated successfully !!!'
          }, () => {
            this.getRollingPlanData();
          });
        }
      });
  }

  saveButtonValidity(): boolean {
    const { rows } = this.state.dataSource;
    return rows.length > 0 && rows.some(row => row.measures.some(measure => measure.isEdited));
  }

  saveFreezeButtonValidity(): boolean {
    const { rows } = this.state.dataSource;

    if (rows.length === 0) {
      return false;
    }

    const unitIdx = rows.findIndex((row) => row.name === 'UNITS');
    const planUnitIdx = rows[unitIdx].measures.findIndex((measure) => measure.name === 'Plan / Quota U');
    const total = calculateActualMeasureTotal(rows[unitIdx].measures[planUnitIdx].quarters);

    return total > 0;
  }

  disableActionBtn(): boolean {
    return this.state.originalDataSource.columns.some(q => q.past);
  }

  render(): React.ReactNode {
    if (this.state.isLoading) {
      return <SectionLoader/>;
    }

    if (this.state.isAutoLoad) {
      return <InitialMessage/>;
    }

    if (this.state.originalDataSource.rows.length === 0) {
      return <NoDataFound/>;
    }

    if (!this.validateJSON()) {
      return <InvalidData/>;
    }

    const renderEventInfo = (events, type: string) => (
      events.map((event, eventIdx) => (
        <React.Fragment key={eventIdx}>
          <p className="mb-1">Event Name: {event.eventName} ({type})</p>
          <p className="mb-1">Country: {event.countryCode}</p>
          <p className="mb-1">Start Date: {event.eventStartDate}</p>
          <p className="mb-0">End Date: {event.eventEndDate}</p>
          {events.length - 1 !== eventIdx && <hr className="my-2"/>}
        </React.Fragment>
      ))
    );

    const headerSection = <Card className="section-header-card">
      <Row>
        <Col md={7} className="align-self-center">

          <Row className="align-items-center">
            <Col md={6}>

              <div className="d-flex">
                <p className="table-title">{this.props.filterData.level} -
                  <span className="sub-title"> {this.props.filterData.products}</span>
                </p>
                <p onClick={() => this.setState(() => this.setState({ isInfoModalOpen: true }))}>
                    <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
                </p>
              </div>

            </Col>

            <Col md={5}>

              <div className="custom-form-container">
                <label htmlFor={'initialize'} className="custom-form-label">Initialize</label>
                <select
                  id="initialize"
                  className="custom-drop-down-field custom-select-width"
                  disabled={this.disableActionBtn()}
                  onChange={(e) => {
                    this.props.isAllowed
                      ? this.setState({ isEditRestrictionAllowed: true })
                      : this.setState({ isEditRestrictionAllowed: false });
                    this.setState({
                      selectedInitialize: e.target.value
                    }, () => {
                      ['STRP', 'ASP', 'FORECAST'].indexOf(this.state.selectedInitialize) !== -1 &&
                      this.copyDataToPlan();
                    });
                  }}
                  value={this.state.selectedInitialize}
                >
                  <option value="">Select</option>
                  {
                    this.state.initializeList.map((initialize, initializeIdx) => (
                      <option
                        key={initializeIdx}
                        value={initialize.value}
                      >
                        {initialize.label}
                      </option>
                    ))
                  }
                </select>
              </div>

            </Col>
          </Row>

        </Col>

        <Col
          md={{ size: 2, offset: 3 }}
          className="align-self-center"
        >

          <div className="d-flex justify-content-end">
            <Dropdown
              isOpen={this.state.isVisibilityMenuOpened}
              toggle={this.toggleVisibilityMenu}
              className="d-inline-block user-dropdown"
            >
              <Tooltip
                content={'Measure Visibility Setting'}
                direction={'top'}
              >
                <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                  <i className="ri-list-settings-line font-size-18"/>
                </DropdownToggle>
              </Tooltip>

              <DropdownMenu className="custom-dropdown-menu dropdown-menu-end">
                <React.Fragment>
                  <Row className="dropdown-menu-box">
                    {
                      this.state.measureVisibilityList.row.map((row, rIdx: number) => (
                        <Col md={4} key={rIdx}>
                          <p className="header-dropdown-label">{row.name}</p>
                          {
                            row.measures.map((measure, mIdx: number) => (
                              <React.Fragment key={mIdx}>
                                <DropdownItem
                                  toggle={false}
                                  className={`${(measure.isVisible !== measure.prevCheck) && 'dropdown-item-changed'}`}
                                >
                                  <div className="d-flex align-items-center">
                                    <Input
                                      id={rIdx + ' ' + mIdx}
                                      type="checkbox"
                                      checked={measure.isVisible}
                                      onChange={() => this.onUpdateVisibilityCheck(rIdx, mIdx)}
                                      className="me-2"
                                    />
                                    <Label for={rIdx + ' ' + mIdx} className="cursor-pointer mb-0">
                                      {measure.displayName}
                                    </Label>
                                  </div>
                                </DropdownItem>
                                {
                                  row.measures.length - 1 !== mIdx &&
                                  <DropdownItem divider/>
                                }
                              </React.Fragment>
                            ))
                          }
                        </Col>
                      ))
                    }
                  </Row>
                  <div className="py-1 text-right">
                    <Button
                      color={'primary'}
                      disabled={this.checkVisibilitySaveButton()}
                      className="btn btn-sm btn-primary ms-3 mx-3"
                      onClick={() => this.updateMeasureVisibility()}
                    >
                      Save
                    </Button>
                  </div>
                </React.Fragment>
              </DropdownMenu>
            </Dropdown>

            <Tooltip
              content={'SKU Level plan'}
              direction={'top'}
            >
              <div
                className="action-btn"
                onClick={() => {
                  if(this.props.filterData.level !== 'Sub Class'){
                    alert('Please Select Product Sub Class');
                  }else{
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    } else {
                      this.props.history.replace({
                        pathname: '/sku-level-rolling-plan',
                        search: '?filter',          //  HO--I180
                        state: { fromRollingPlan: true } 
                      });
                    }
                  }
                }}
              >
                <img
                  src={DirectionIcon}
                  alt="direction-icon"
                  height={'24px'}
                  className="edit-icon-position"
                />
              </div>
            </Tooltip>

            <Tooltip
              content={'Edit All'}
              direction={'top'}
            >
              <div
                className="action-btn"
                onClick={() => {
                  if (this.props.isAllowed) {
                    this.setState({ isEditRestrictionAllowed: true });
                  } else {
                    this.props.history.replace({
                      pathname: '/rolling-plan/edit-all',
                      search: '?filter=true',          //  HO--I180
                      state: { fromRollingPlan: true } 
                    });
                  }
                }}
              >
                <img
                  src={EditAllIcon}
                  alt="edit-icon"
                  height={'24px'}
                  className="edit-icon-position"
                />
              </div>
            </Tooltip>

            <Tooltip
              content={'Edit measures'}
              direction={'top'}
            >
              <div
                className="action-btn"
                onClick={() => {
                  this.props.isAllowed
                    ? this.setState({ isEditRestrictionAllowed: true })
                    : this.setState({ isEditable: true })
                }}
              >
                <img src={EditIcon} alt="edit-icon" className="edit-icon-position"/>
              </div>
            </Tooltip>

            <Dropdown
              isOpen={this.state.isMoreMenuOpened}
              toggle={this.toggleMoreMenu}
              className="d-inline-block user-dropdown"
            >
              <Tooltip content={'More'} direction={'top'}>
                <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                  <img src={MoreIcon} alt="more-icon"/>
                </DropdownToggle>
              </Tooltip>

              <DropdownMenu className="dropdown-menu-end">
                <div className="position-relative">
                  <DropdownItem
                    disabled={this.disableActionBtn()}
                    onClick={() => {
                      if (this.props.isAllowed) {
                        this.setState({ isEditRestrictionAllowed: true });
                      }
                    }}
                  >
                    Import
                  </DropdownItem>
                  <input
                    type="file"
                    accept=".csv,
                      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                      application/vnd.ms-excel"
                    disabled={this.disableActionBtn()}
                    onChange={(e) => {
                      this.importTemplate(e);
                      this.toggleMoreMenu();
                    }}
                  />
                </div>
                <DropdownItem divider/>

                <Dropdown
                  isOpen={this.state.isDownloadMenu}
                  toggle={this.toggleDownloadMenu}
                  className="d-inline-block user-dropdown"
                  direction="end"
                >
                  <DropdownToggle className={styles['dropdown-toggle']}>Download Template</DropdownToggle>
                  <DropdownMenu id={styles['downloadDropdown']}>
                    <DropdownItem onClick={() => this.downloadTemplate('units')}>Units</DropdownItem>
                    <DropdownItem onClick={() => this.downloadTemplate('revenue')}>Revenue</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <DropdownItem divider/>

                {/*<DropdownItem
                  onClick={() => {
                    this.freezePlan();
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >Freeze Plan</DropdownItem>
                <DropdownItem divider/>*/}

                <DropdownItem
                  disabled={this.state.isgoalSeekDisabled}
                  onClick={() => {
                    this.goalSeek();
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >Goal Seek</DropdownItem>
                <DropdownItem divider/>

                {/*<DropdownItem
                  onClick={() => {
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >SKU Level Plan</DropdownItem>
                <DropdownItem divider/>

                <DropdownItem
                  onClick={() => {
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    } else {
                      this.props.history.replace('/rolling-plan/edit-all?filter');
                    }
                  }}
                >Edit All</DropdownItem>*/}

                <DropdownItem
                  onClick={() => {
                    this.downloadTemplate('frozen');
                    if (this.props.isAllowed) {
                      this.setState({ isEditRestrictionAllowed: true });
                    }
                  }}
                >Download Freeze Plan</DropdownItem>
                <DropdownItem divider/>

              </DropdownMenu>
            </Dropdown>

            <i className={`ri-arrow-${this.state.isExpanded ? 'up' : 'down'}-s-line ps-1 cursor-pointer`}
               style={{ fontSize: '22px' }}
               onClick={() => this.setState({ isExpanded: !this.state.isExpanded })}
            />
          </div>

        </Col>
      </Row>
    </Card>;
    const bodySection = <div className="table-responsive table-outline custom-table sticky-table">
      <Table className="mb-0">
        <thead>
        <tr>
          <th className="dark-bg-cell"/>
          {
            this.state.dataSource.columns.map((col, colIdx: number) => (
              <th
                key={colIdx}
                colSpan={col.isExpanded ? totalWeeksOfSelectedQuarter(this.state.dataSource.columns, colIdx) : 1}
              >
                <span
                  className="toggle-col"
                >
                {col.name}
                  <i
                    className={`${col.isExpanded ? 'ri-checkbox-indeterminate-fill' : 'ri-add-box-fill'} ms-sm-2`}
                    onClick={() => {
                      this.props.isAllowed
                        ? this.setState({ isEditRestrictionAllowed: true })
                        : this.onExpandColumn(colIdx, col.isExpanded);
                    }}
                  />
                </span>
              </th>
            ))
          }
          <th
            className="table-header-text dark-bg-cell v-middle"
            style={{ whiteSpace: 'nowrap' }}
          >
            Grand Total
          </th>
        </tr>
        {
          this.isColumnExpanded() &&
          <React.Fragment>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((quarter, qIdx: number) => (
                  <React.Fragment key={qIdx}>
                    {
                      quarter.isExpanded
                        ? quarter.months.map((month, mIdx: number) => (
                          <th
                            key={mIdx}
                            colSpan={quarter.isExpanded ? month.weeks.length : 1}
                            className="text-center"
                          >
                            {month.name}
                          </th>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              <th/>
              <th className="dark-bg-cell"/>
            </tr>
            <tr>
              <th className="dark-bg-cell"/>
              {
                this.state.dataSource.columns.map((quarter, qIdx: number) => (
                  <React.Fragment key={qIdx}>
                    {
                      quarter.isExpanded
                        ? quarter.months.map((month, mIdx: number) => (
                          <React.Fragment key={mIdx}>
                            {
                              quarter.isExpanded &&
                              month.weeks.map((week, wIdx: number) => (
                                <th
                                  key={wIdx}
                                  className="text-center"
                                >
                                  <div className="d-flex justify-content-between">
                                    <span>{week.name}</span>
                                    {
                                      ((!!week.eventInfo?.MAIN && week.eventInfo?.MAIN?.length > 0) ||
                                        (!!week.eventInfo?.Other && week.eventInfo?.Other?.length > 0)) &&
                                      (
                                        <Tooltip
                                          content={
                                            <React.Fragment>
                                              {week.eventInfo?.Other && renderEventInfo(week.eventInfo.Other, 'Other')}
                                              {week.eventInfo?.MAIN && renderEventInfo(week.eventInfo.MAIN, 'Main')}
                                            </React.Fragment>
                                          }
                                          style={{ textAlign: 'left', top: '30px' }}
                                        >
                                          <i
                                            className={`mdi mdi-note cursor-pointer ${!!week.eventInfo?.MAIN && 'text-danger'}`}/>
                                        </Tooltip>
                                      )
                                    }
                                  </div>
                                </th>
                              ))
                            }
                            {
                              quarter.months.length - 1 === mIdx &&
                              <th className="dark-bg-cell text-center">Total</th>
                            }
                          </React.Fragment>
                        ))
                        : <th/>
                    }
                  </React.Fragment>
                ))
              }
              <th className="dark-bg-cell"/>
            </tr>
          </React.Fragment>
        }
        </thead>

        <tbody>
        {
          this.state.dataSource.rows.map((row, rIdx: number) => (
            <React.Fragment key={rIdx}>
              <tr className="table-header-outline bg-white">
                <td className="table-header-text text-right">{row.name}</td>
                {
                  this.state.dataSource.columns.map((quarter, qIdx: number) => (
                    <React.Fragment key={qIdx}>
                      {
                        quarter.isExpanded
                          ? quarter.months.map((month, mIdx: number) => (
                            <React.Fragment key={mIdx}>
                              {
                                quarter.isExpanded &&
                                month.weeks.map((week, wIdx: number) => (
                                  <td key={wIdx}/>
                                ))
                              }
                              {
                                quarter.months.length - 1 === mIdx && <td className="dark-bg-cell"/>
                              }
                            </React.Fragment>
                          ))
                          : <td/>
                      }
                    </React.Fragment>
                  ))
                }
                <td className="dark-bg-cell"/>
              </tr>
              {
                row.measures.map((measure, mIdx) => (
                  <React.Fragment key={mIdx}>
                    {
                      measure.isVisible &&
                      <tr>
                        <td className="table-data-text dark-bg-cell text-right">{measure.displayName}</td>
                        {
                          measure.quarters.map((quarter, qIdx) => (
                            <React.Fragment key={qIdx}>
                              {
                                !quarter.isExpanded
                                  ? <td className={`${quarter.isPast ? 'disabled-cell' : ''} text-right`}>
                                    {/*<span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                        {measure.datatype === 'currency' && measure.symbol}
                                      </span>*/}
                                    {
                                      (measure.editable && this.state.isEditable && !this.isColumnExpanded() && !quarter.isPast)
                                        ? <input
                                          type="number"
                                          className={
                                            `${(quarter.isEdited)
                                              ? 'editable-input-new'
                                              : 'editable-input'}
                                            ${quarter.isDisabled && ' readonly-input'}
                                            ${IsNegative(quarter.value) && ' error-input'}`
                                          }
                                          readOnly={quarter.isDisabled}
                                          onChange={(e) => {
                                            this.updateQuarterCalculation(this.state.dataSource.rows, rIdx, mIdx, qIdx, row.name, measure.name, e);
                                          }}
                                          value={quarter.value}
                                        />
                                        : <span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                            {/*{NumberWithCommas(Math.round(quarter.value))}*/}
                                          {NumberWithCommas(quarter.value)}
                                          </span>
                                    }
                                    {/*<span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                      {measure.datatype === 'percentage' && '%'}
                                    </span>*/}
                                  </td>
                                  : quarter.weeks.map((week, wIdx: number) => (
                                    <React.Fragment key={wIdx}>
                                      <td className={`${week.isPast ? 'disabled-cell' : ''} text-right`}>
                                        {/*<span className={`${IsNegative(week.value) && 'text-danger'}`}>
                                          {measure.datatype === 'currency' && measure.symbol}
                                        </span>*/}
                                        {
                                          (measure.editable && this.state.isEditable && this.isColumnExpanded() && !week.isPast)
                                            ? <input
                                              type="number"
                                              className={
                                                `${(week.isEdited)
                                                  ? 'editable-input-new'
                                                  : 'editable-input'}
                                                ${week.isDisabled && ' readonly-input'}
                                                ${IsNegative(week.value) && ' error-input'}`
                                              }
                                              readOnly={week.isDisabled}
                                              onChange={(e) => {
                                                this.updateWeekCalculation(this.state.dataSource.rows, rIdx, mIdx, qIdx, wIdx, row.name, e);
                                              }}
                                              value={week.value}
                                            />
                                            : <span className={`${IsNegative(week.value) && 'text-danger'}`}>
                                                {/*{NumberWithCommas(Math.round(week.value))}*/}
                                              {NumberWithCommas(week.value)}
                                              </span>
                                        }
                                        {/*<span className={`${IsNegative(week.value) && 'text-danger'}`}>
                                          {measure.datatype === 'percentage' && '%'}
                                        </span>*/}
                                      </td>
                                      {
                                        quarter.weeks.length - 1 === wIdx &&
                                        <td className="dark-bg-cell text-right">
                                          <span className={`${IsNegative(quarter.value) && 'text-danger'}`}>
                                            {/*{measure.datatype === 'currency' && measure.symbol}*/}
                                            {/*{NumberWithCommas(Math.round(quarter.value || 0))}*/}
                                            {NumberWithCommas(quarter.value || 0)}
                                            {/*{measure.datatype === 'percentage' && '%'}*/}
                                          </span>
                                        </td>
                                      }
                                    </React.Fragment>
                                  ))
                              }
                            </React.Fragment>
                          ))
                        }
                        <td className="dark-bg-cell text-right">
                          {/*<span className={`${IsNegative(measure.value) && 'text-danger'}`}>
                              {measure.datatype === 'currency' && measure.symbol}
                            </span>*/}
                          {
                            (measure.editable && this.state.isEditable && !this.isColumnExpanded() && !measure.isPast)
                              ? <input
                                type="number"
                                className={
                                  `${(measure.isEdited)
                                    ? 'editable-input-new'
                                    : 'editable-input'}
                                    ${measure.isDisabled && ' readonly-input'}
                                    ${IsNegative(measure.value) && ' error-input'}`
                                }
                                readOnly={measure.isDisabled}
                                onChange={(e) => {
                                  this.updateMeasureCalculation(this.state.dataSource.rows, rIdx, mIdx, row.name, e);
                                }}
                                value={measure.value}
                              />
                              : <span className={`${IsNegative(measure.value) && 'text-danger'}`}>
                                    {/*{NumberWithCommas(Math.round(measure.value || 0))}*/}
                                {NumberWithCommas(measure.value || 0)}
                                </span>
                          }
                          {/*<span className={`${IsNegative(measure.value) && 'text-danger'}`}>
                                {measure.datatype === 'percentage' && '%'}
                              </span>*/}
                        </td>
                      </tr>
                    }
                  </React.Fragment>
                ))
              }
            </React.Fragment>
          ))
        }
        </tbody>
      </Table>
    </div>;

    return (
      <React.Fragment>
        <div className="mb-2">
          {headerSection}
          {this.state.isExpanded && bodySection}
        </div>

        {
          this.state.isEditable &&
          <ActionCard
            onCancel={() => {
              this.setState({
                isEditable: false,
                disableSave: false
              }, () => {
                this.dataInit();
              });
              this.props.UpdateEditRestriction(false);
            }}
            onSave={() => this.updateRollingPlanData(false)}
            onSaveAndFreeze={() => this.updateRollingPlanData(true)}
            isSaveDisabled={!this.saveButtonValidity()}
            isSaveAndFreezeDisabled={!this.saveFreezeButtonValidity()}
          />
        }

        <UnsavedDataModal
          isOpen={this.state.isEditRestrictionAllowed}
          toggle={() => this.setState({ isEditRestrictionAllowed: !this.state.isEditRestrictionAllowed })}
          removeChanges={() => {
            this.props.UpdateEditRestriction(false);
            this.setState({
              isEditable: false,
              isEditRestrictionAllowed: false
            }, () => {
              this.dataInit();
            });
          }}
        />

        <SuccessModal
          isOpen={this.state.isModalOpened}
          toggle={() => this.setState({ isModalOpened: !this.state.isModalOpened })}
          message={this.state.successMessage}
        />

        <SuccessModal
          isOpen={this.state.isRunningModal}
          toggle={() => this.setState({ isRunningModal: !this.state.isRunningModal })}
          message={'Another user using same filters for saving, Please try after sometime'}
        />

        {<HelpModal
          isOpen={this.state.isInfoModalOpen}
          toggle={() => this.setState({ isInfoModalOpen: !this.state.isInfoModalOpen })}
          docUrl={`Content/Topics_sales_plan/Managing Rolling Plans.htm`}
        />}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(PlanningTable));
